import { CoreIcon } from '../core-icon';
import installSVG from '../../assets/icons/install.svg';
import type { IconProps } from '../core-icon';

export const InstallIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={installSVG} {...props} />;
};
